import ContentCard from './content-card';
import Container from './container';
ContentCard.Container = Container;
export default ContentCard;
//# sourceMappingURL=index.js.map